export const isMobileDevice = () => {
  return window.innerWidth <= 768
}